import React from "react";
import { useParams } from "react-router-dom";
import NoPaymentDetailFound from "./NoPaymentDetailFound";
import PaymentDetailView from "./PaymentDetailView";

/**
 * Full-page payment detail (URL route). Opens from invoice, order, receipt links, etc.
 * The payments list uses {@link PaymentDetailModal} instead.
 */
const PaymentDetail: React.FC = () => {
  const { paymentId } = useParams<{ paymentId: string }>();

  if (!paymentId) {
    return <NoPaymentDetailFound />;
  }

  return <PaymentDetailView presentation="page" paymentId={paymentId} />;
};

export default PaymentDetail;
